import axios from "axios";
import { setAlert } from "./alert";
import { DOWNLOAD_DEVICE_STATISTICS_FAIL } from "../action/types";
import customConfig from "../config";
import env from "../env";

function DownloadFile(response, fileName, fileType) {
  const blob = new Blob([response.data], { type: fileType });
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
}

async function extractBackendMessage(err) {
  const data = err?.response?.data;
  if (!data) return null;

  // For responseType=blob, backend JSON errors arrive as Blob.
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const text = await data.text();
      if (!text) return null;
      const parsed = JSON.parse(text);
      return parsed?.message || null;
    } catch (_) {
      return null;
    }
  }

  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      return parsed?.message || null;
    } catch (_) {
      return null;
    }
  }

  return data?.message || null;
}

function normalizeCategoryForStatsDownload(category) {
  const raw = String(category || "").trim().toUpperCase();
  if (!raw) return raw;
  if (raw === "ODMIRB-AC") return "AC";
  return raw;
}

function getFriendlyDownloadErrorMessage(backendMessage) {
  if (!backendMessage) return null;
  if (backendMessage.toLowerCase().includes("category must be one of")) {
    return "Selected category is not supported. Please choose another category.";
  }
  return backendMessage;
}

// Download file with device onboard statistics
export const downloadDeviceStatistics = (category) => async (dispatch) => {
  const normalizedCategory = normalizeCategoryForStatsDownload(category);
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    };
    const res = await axios.post(
      `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/deviceManagement/devices/download/deviceOnboardStat/${normalizedCategory}`,
      null,
      config
    );
    DownloadFile(res, `${normalizedCategory}_Onboard.csv`, "text/csv");
  } catch (err) {
    const backendMessage = await extractBackendMessage(err);
    if (!err.response) {
      dispatch(setAlert(customConfig.serverDownMsg, "danger"));
    } else if (backendMessage) {
      dispatch(setAlert(getFriendlyDownloadErrorMessage(backendMessage), "danger"));
    } else {
      dispatch(setAlert(customConfig.downloadErrorMsg, "danger"));
    }
    dispatch({
      type: DOWNLOAD_DEVICE_STATISTICS_FAIL,
    });
  }
};

// Download file with device offboard statistics
export const downloadDeviceOffboardStatistics = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    };
    const res = await axios.post(
      `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/deviceManagement/devices/download/deviceOffboardStat`,
      null,
      config
    );
    DownloadFile(res, "Offboard.csv", "text/csv");
  } catch (err) {
    const backendMessage = await extractBackendMessage(err);
    if (!err.response) {
      dispatch(setAlert(customConfig.serverDownMsg, "danger"));
    } else if (backendMessage) {
      dispatch(setAlert(backendMessage, "danger"));
    } else {
      dispatch(setAlert(customConfig.downloadErrorMsg, "danger"));
    }
    dispatch({
      type: DOWNLOAD_DEVICE_STATISTICS_FAIL,
    });
  }
};
